import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NoDataFound from "./NoDataFound";
import ImageLoading from "./ImageLoading";

export const NotificationPopup = ({ closeFunction }) => {
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [list, setList] = useState([]);
  const data = [
    {
      id: 4,
      user_details: {
        id: "11014965-6ced-40de-84cc-e43be94f842f",
        name: "Mridul",
      },
      notification_details: {
        message: "Mridul has successfully pledged units of ₹0 on 2024-07-09.",
        amount: 0,
      },
      key: "pledged",
      created_at: "2024-07-09",
      is_read: true,
    },
  ];

  const fetchNotifications = async (controller) => {
    setNoData(false);
    setLoading(true);
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/dashboards/notifications?per_page=50&page=1&is_read=false`,
        options
      );
      if (res.data.notifications.length > 0) {
        setList(res.data.notifications);
      } else {
        setNoData(true);
      }
      setLoading(false);

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const handleOverlay = (e) => {
    if (e.target === e.currentTarget) closeFunction(false);
  };
  const navigate = useNavigate();
  const getNotificationText = (status) => {
    if (!status) return "";
    switch (status) {
      case "pledged":
        return "has successfully pledged units of";
      case "disbursed":
        return "has successfully disbursed an amount";
      case "overdue_emi":
        return "has missed their last EMI of";
      case "prepayment_success":
        return "has completed prepayment of";
      default:
        return "";
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchNotifications(controller);
    return () => {
      controller.abort();
    };
  }, []);
  return (
    <div className="overlayModal2" onClick={handleOverlay}>
      <div className=" max-h-[600px] w-[500px] bg-white absolute !z-[100] top-[70px] left-48 shadow-xl rounded-xl px-4 pt-4">
        <div className="flex w-full justify-between items-center mb-6">
          <p className=" font-bold text-base">Your Notification</p>
          <button onClick={() => closeFunction(false)}>
            <IoMdClose style={{ width: "20px", height: "20px" }} />
          </button>
        </div>
        {noData && (
          <div className="w-full flex items-center justify-center bg-white mt-4 rounded-lg mb-6">
            <p className=" text-sm font-medium text-[#a8a8a8]">
              You have no new notifications.
            </p>
          </div>
        )}
        {loading && (
          <div className="w-full  flex items-center justify-center bg-white mt-4 rounded-lg">
            <ImageLoading />
          </div>
        )}
        {!noData && !loading && (
          <div className=" max-h-[480px]  overflow-y-auto">
            {list.map((item, index) => (
              <div
                key={index}
                className=" w-full  rounded bg-[#e6ebed] px-[8px] flex items-center mb-[4px] min-h-[60px] py-2"
              >
                <p className="bg-[#f0f9ff] rounded-full min-h-[32px] min-w-[32px] flex items-center justify-center text-[#0710ed] text-sm font-bold">
                  {item?.user_details?.name
                    ? item?.user_details?.name[0].toUpperCase()
                    : "--"}
                </p>
                <div className=" min-h-[40px] ml-3 text-[13px] ">
                  <p className=" font-normal ">
                    <span className="font-semibold">
                      {item.user_details?.name || "--"}
                    </span>{" "}
                    {getNotificationText(item.key)}{" "}
                    <span className="font-semibold">
                      ₹{item.notification_details?.amount || "--"}
                    </span>{" "}
                    on
                  </p>
                  <p className=" font-semibold ">{item.created_at || "--"}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        <center className=" pb-3">
          {" "}
          <button
            className="ml-auto mr-auto mt-[18px] flex items-center text-[#00394d] font-semibold text-[12px]"
            onClick={() => {
              closeFunction(false);
              navigate(`/notification`);
            }}
          >
            {noData ? "View Previous Notifications" : "View All"}{" "}
            <span className="ml-[8px]">
              <FaArrowRight style={{ width: "17px", height: "17px" }} />
            </span>
          </button>
        </center>

        {/* <div className=" w-full h-[56px] rounded bg-[#e6ebed] px-[8px] flex items-center">
        <p className="bg-[#f0f9ff] rounded-full h-[32px] w-[32px] flex items-center justify-center text-[#0710ed] text-sm font-bold">
          M
        </p>
        <div className=" h-[40px] ml-3 text-sm mb-[4px]  mt-1">
          <p className=" font-normal ">
            <span className="font-semibold">Mridul Manhas</span> has
            successfully pledged units of{" "}
            <span className="font-semibold">₹46.27</span> on
          </p>
          <p className=" font-semibold ">22-06-2024</p>
        </div>
      </div> */}
      </div>
    </div>
  );
};
